import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { onIdTokenChanged } from "firebase/auth";
import { auth } from "../firebase";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(auth.currentUser);
  const [idToken, setIdToken] = useState(null);

  useEffect(() => {
    const unsub = onIdTokenChanged(auth, async (u) => {
      setUser(u);
      if (u) {
        try {
          const token = await u.getIdToken();
          setIdToken(token);
        } catch (err) {
          console.error("Failed to get ID token:", err);
          setIdToken(null);
        }
      } else {
        setIdToken(null);
      }
    });
    return unsub;
  }, []);

  const getIdToken = useCallback(async (forceRefresh = false) => {
    if (!auth.currentUser) return null;
    const token = await auth.currentUser.getIdToken(forceRefresh);
    setIdToken(token);
    return token;
  }, []);

  return (
    <AuthContext.Provider value={{ user, idToken, getIdToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}